/** A table's columns, header and rows alike, by their share of the width. */
export type BoardColumns = Record<string, { title: string; flex: number }>;

export const kBoardRowHeight = 84;
